import { render, staticRenderFns } from "./ChipDateFilter.vue?vue&type=template&id=d560998e"
import script from "./ChipDateFilter.vue?vue&type=script&lang=js"
export * from "./ChipDateFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports